import { ApolloLink, useApolloClient } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { createContext, useContext, useEffect, useState } from "react";

interface IMaintenanceProviderProps {
  children: React.ReactNode;
}

const Context = createContext(false);

export function MaintenanceProvider({
  children,
}: IMaintenanceProviderProps): React.ReactElement {
  const client = useApolloClient();

  const [isMaintenance, setIsMaintenance] = useState(false);

  useEffect(() => {
    const oldLink = client.link;
    const errorLink = onError(({ graphQLErrors }) => {
      if (graphQLErrors?.some(({ message }) => message === "Maintenance")) {
        setIsMaintenance(true);
      }
    });

    client.setLink(ApolloLink.from([errorLink, oldLink]));

    return () => {
      client.setLink(oldLink);
    };
  }, [client]);

  return <Context.Provider value={isMaintenance}>{children}</Context.Provider>;
}

export function useMaintenance(): boolean {
  return useContext(Context);
}
